import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AlertsPopoverComponent } from "./alerts-popover/alerts-popover.component";
import { IconsModule } from "@va/core-library/icons";

import { FormsModule } from "@angular/forms";
import { LidAlertPopoverComponent } from "./lid-alert-popover/lid-alert-popover.component";
import { LineItemDeltaAlertComponent } from "./line-item-delta-alert/line-item-delta-alert.component";
import { AlertsPopoverModule } from "@va/core-library/alerts-popover";

import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzSwitchModule } from "ng-zorro-antd/switch";
@NgModule({
  declarations: [
    AlertsPopoverComponent,
    LidAlertPopoverComponent,
    LineItemDeltaAlertComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    NzCheckboxModule,
    NzButtonModule,
    NzSkeletonModule,
    NzRadioModule,
    NzToolTipModule,
    NzSwitchModule,
    FormsModule,
    AlertsPopoverModule,
  ],
  exports: [
    AlertsPopoverComponent,
    LidAlertPopoverComponent,
    LineItemDeltaAlertComponent,
  ],
})
export class AlertsModule {}
